var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _g, _path7, _path8, _path9, _polygon2, _polygon3, _polygon4, _path0, _path1, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHoodieSnap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-miterlimit: 10;\n        stroke-width: .1px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n      }\n\n      .cls-2 {\n        stroke-width: .5px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke-width: .75px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.8412915,21.8838505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.1197323,21.8838505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.8964937,33.9318139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.7524107,19.217775c-.4445131-.4979774-.8047178-1.606116-.7442513-2.7981402.0604664-1.1920241.9627692-2.0780782.7741373-6.3955397-.2332277-5.3381856-4.6127259-5.3381856-4.6127259-5.3381856h-1.088396s-.2013257,0-.2013257,0h-1.088396s-4.3794982,0-4.6127259,5.3381856c-.1886318,4.3174615.7136709,5.2035156.7741373,6.3955397.0604664,1.1920241-.2997383,2.3001628-.7442513,2.7981402"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.4592342,21.8838505s.1946043-.1263969.508486-.381187c.0042434-.0034445.0085085-.0069125.0127953-.0104039,1.2093487-.9849757,4.1388391-3.8378942,4.6097285-8.669504,0,0,.4923696-4.5093913-4.5090692-4.5089529h-.2013257c-5.0014388-.0004384-4.5090692,4.5089529-4.5090692,4.5089529.4692141,4.8144207,3.3795667,7.6642039,4.5967561,8.6589205"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.8267929,32.9745902c.6725315,5.8756329,1.2994061,15.6056968.3502907,18.2822816h-20.3785174c-.9491154-2.6765848-.3222408-12.4066487.3502907-18.2822816"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.1568538 48.5377635 42.5727674 51.2508576 34.8070275 51.2508576 27.0412877 51.2508576 26.4571894 48.5377635 29.0081424 40.9888012 34.8070275 40.9888012 40.8045763 40.9888012 43.1568538 48.5377635"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.4393636,20.6702758c.0823873,0,.1491727.0667837.1491727.1491689l.0491.1982663c.0507966-.0507955.0822579-.1209259.0822579-.1982663,0-.1546821-.1258473-.2805234-.2805307-.2805234h0c-.1546834,0-.2805307.1258414-.2805307.2805234,0,.1160118.0707895.2158007.1714415.2584441l-.0400835-.2584441c0-.0823852.0667854-.1491689.1491727-.1491689"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.4344963,20.7197783c.0823873,0,.1491727.0667837.1491727.1491689l-.0400835.2584441c.100652-.0426434.1714415-.1424323.1714415-.2584441,0-.1546821-.1258473-.2805234-.2805307-.2805234h0c-.1546834,0-.2805307.1258414-.2805307.2805234,0,.0773404.0314613.1474708.0822579.1982663l.0491-.1982663c0-.0823852.0667854-.1491689.1491727-.1491689"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.4711055,29.1431509v1.0055444c0,.0532381.0435596.0967966.0967991.0967966h.0123875c.0532395,0,.0967991-.0435585.0967991-.0967966v-1.0055444"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.2959603,20.8194436s.2496875,1.9678261.0289573,3.6086308c-.2947414,2.1909693.0574356,5.0296403.146188,5.0197359l.2059856.0000327c.0912585-.2090545-.3407148-2.4900404-.0827856-4.6644977s0-3.9639018,0-3.9639018c0,0-.0284079-.0735266-.1491727-.0735266s-.1491727.0735266-.1491727.0735266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.4027543,29.1926534v1.0055444c0,.0532381-.0435596.0967966-.0967991.0967966h-.0123875c-.0532395,0-.0967991-.0435585-.0967991-.0967966v-1.0055444"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.5778996,20.8689461s-.2496875,1.9678261-.0289573,3.6086308c.2947414,2.1909693-.0574356,5.0296403-.146188,5.0197359l-.2059856.0000327c-.0912585-.2090545.3407148-2.4900404.0827856-4.6644977-.2579292-2.1744573,0-3.9639018,0-3.9639018,0,0,.0284079-.0735266.1491727-.0735266s.1491727.0735266.1491727.0735266Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.4717626,22.4899156"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.812065,32.9862373c.8404229,2.9406523,2.8427288,8.9163808,4.1447664,13.9469486.7129349,2.7545147,2.4224782,8.8879606,4.1225742,9.5993819l4.2434538-.8525069c1.3187096-1.8102799-2.7461595-14.7056014-3.9954035-19.9196385-.8226673-3.4336292-3.2723167-11.3294713-4.7509281-13.1628633l-.0668882-.0861152c-.7768632-1.0114752-7.7831759-3.2936689-7.7831759-3.2936689-2.6731335,2.6634723-4.8851722,2.6660754-4.8851722,2.6660754h-.882504s.0175018,0,.0175018,0h-.882504s-2.2120387-.0026031-4.8851722-2.6660754c0,0-6.9599871,2.2606651-7.7368503,3.2721403l-.0000002.0000003c-.2007668.2361901-.3841594.4862365-.5386839.7549639-1.4365513,2.4982495-3.4973111,9.2993429-4.2605345,12.4848667-1.249244,5.2140371-5.3141131,18.1093586-3.9954035,19.9196385l4.2434538.8525069c1.700096-.7114212,3.4096393-6.8448671,4.1225742-9.5993819,1.3020376-5.0305678,3.2397107-10.9756201,4.0801336-13.9162724"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.5096395,22.5114439"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.973341 54.4027146 24.7981957 51.2502053 45.170943 51.2502053 44.9957976 54.4027146 24.973341 54.4027146"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "55.2007415 56.1064172 53.0790154 56.5326721 54.1298054 59.6859744 55.8504606 59.3402947 57.571128 58.9946125 57.3224675 55.6801623 55.2007415 56.1064172"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14.7970036 56.0726466 16.9187296 56.4989015 15.8679397 59.6522038 14.1472845 59.3065241 12.4266171 58.9608419 12.6752775 55.6463917 14.7970036 56.0726466"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.2086131,19.217775"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.0435284,19.4061849"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.9167296,
    y: 22.0830271,
    width: 1.9743435,
    height: 10.4647236
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.9062082,
    cy: 23.2863631,
    rx: 0.3325478,
    ry: 0.3597903
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.9062082,
    cy: 31.3354707,
    rx: 0.3325478,
    ry: 0.3597903
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.9062082,
    cy: 28.6524348,
    rx: 0.3325478,
    ry: 0.3597903
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.9062082,
    cy: 25.969399,
    rx: 0.3325478,
    ry: 0.3597903
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHoodieSnap);
export default __webpack_public_path__ + "static/media/Menu_Hoodie_Snap.d2febd5f78e19713786393f01ab4e595.svg";
export { ForwardRef as ReactComponent };